import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined" && window.console) {
      console.error("UI crashed:", error, info);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          margin: 24,
          padding: 16,
          borderRadius: 12,
          background: "color-mix(in srgb, var(--color-danger) 8%, var(--ui-surface))",
          border: "1px solid color-mix(in srgb, var(--color-danger) 24%, var(--ui-border))",
          color: "var(--ui-text)",
          fontFamily: "inherit",
        }}
      >
        <strong>Something went wrong.</strong>
        <div style={{ marginTop: 6, fontSize: 13 }}>
          Please refresh the page. If this keeps happening, share the console error with support.
        </div>
      </div>
    );
  }
}
